// src/utils/formatters.js

/**
 * Formate un nombre en devise (XOF, EUR, USD)
 * @param {number} value - La valeur à formater
 * @param {string} currency - La devise (XOF, EUR, USD)
 * @returns {string} - La valeur formatée
 */
// src/utils/formatters.js

/**
 * Formate un nombre en devise (FCFA) avec 2 décimales
 * @param {number|string} value - La valeur à formater
 * @returns {string} - La valeur formatée (ex: 1 234 567.89 FCFA)
 */
export const formatCurrency = (value) => {
    if (value === null || value === undefined) return '0.00 FCFA';
    
    // Convertir en nombre
    const number = typeof value === 'string' ? parseFloat(value) : value;
    
    // Formater avec 2 décimales et espaces comme séparateurs de milliers
    return number.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) + ' FCFA';
};

/**
 * Formate un nombre en devise sans le symbole FCFA, avec 2 décimales
 * @param {number|string} value - La valeur à formater
 * @returns {string} - La valeur formatée (ex: 1 234 567.89)
 */
export const formatCurrencys = (value) => {
    if (value === null || value === undefined) return '0.00';
    
    const number = typeof value === 'string' ? parseFloat(value) : value;
    return number.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

// src/utils/formatters.js
export const nettoyerMontant = (valeur) => {
    if (valeur === null || valeur === undefined) return 0;
    if (typeof valeur === 'number') return valeur;
    
    // Si c'est une chaîne, on nettoie
    const nettoye = String(valeur).replace(/[^\d.-]/g, '');
    const nombre = parseFloat(nettoye);
    return isNaN(nombre) ? 0 : nombre;
};



// Ajoutez cette fonction à votre fichier formatters.js
export const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '-';
        
        // Format: DD/MM/YYYY HH:MM
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch (error) {
        console.error("Erreur formatDateTime:", error);
        return '-';
    }
};
// Version plus robuste avec gestion d'erreur
export const nettoyerMontantSecurise = (valeur) => {
    try {
        if (valeur === null || valeur === undefined) return 0;
        if (typeof valeur === 'number') return isNaN(valeur) ? 0 : valeur;
        
        const nettoye = String(valeur).replace(/[^\d.-]/g, '');
        const nombre = parseFloat(nettoye);
        return isNaN(nombre) ? 0 : nombre;
    } catch (error) {
        console.warn("Erreur lors du nettoyage du montant:", valeur);
        return 0;
    }
};
/**
 * Formate un nombre avec séparateur de milliers
 * @param {number} value - La valeur à formater
 * @returns {string} - La valeur formatée
 */
export const formatNumber = (value) => {
  if (value === null || value === undefined) return '0';
  return value.toLocaleString('fr-FR');
};

/**
 * Formate un pourcentage
 * @param {number} value - La valeur à formater
 * @param {number} decimals - Nombre de décimales
 * @returns {string} - La valeur formatée
 */
export const formatPercent = (value, decimals = 1) => {
  if (value === null || value === undefined) return '0%';
  return `${value.toFixed(decimals)}%`;
};

/**
 * Formate une date
 * @param {string} dateStr - La date à formater
 * @returns {string} - La date formatée
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

/**
 * Formate un mois
 * @param {number} month - Le mois (1-12)
 * @returns {string} - Le mois formaté
 */
export const formatMonth = (month) => {
  const months = [
    'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
    'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'
  ];
  return months[month - 1] || '';
};